<!-- Copied from Desp header code -->
<!-- Header -->
<div id="desp-header-container">
   <div id="desp-header-inner-container">
      <!-- Left container -->
      <div id="left-container">
         <a class="header-link"  routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }" href="https://platform.destine.eu/" target="_blank">
          <img id="eu-flag-de" alt="destine platform home" src="logos/destination_earth_logo.svg" >
         </a>

      </div>
      <!-- Central container -->
      <div id="central-container">
         <a class="header-link"  routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }" routerLink="/list">Quantum Emulators</a>
         <a class="header-link" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }"  routerLink="/consumption">My Consumption</a>
         <a class="header-link" routerLinkActive="active-link"
            [routerLinkActiveOptions]="{ exact: true }" routerLink="/">About </a>
      </div>
      <!-- Right container -->
      <div id="right-container">
         <div id="info-container">
            <div id="info-button" (click)="toggleHeaderInfoMenu()">
               <i data-feather="info" id="info-icon"></i>
            </div>
            <!-- Info Menu -->
            <div id="info-frame">
               <a class="frame-link" href="https://platform.destine.eu/support/" target="_blank">Support</a>
               <a *ngIf="DOC_LINK!=='#' && DOC_LINK!==''" class="frame-link"  [href]="DOC_LINK" target="_blank">Documentation</a>
            </div>
         </div>
         <div id="user-container">
            <div id="login-div" class="desp-button" (click)="toggleHeaderUserMenu()">
               <a class="login-a not-logged" href="#">
                  <i data-feather="log-in" class="login-icon not-logged"></i>
                  <p class="login-text not-logged">Sign In</p>
               </a>
               <a class="login-a logged">
                  <i data-feather="user" class="login-icon logged"></i>
                  <p class="login-text logged">{{ preferredUsername }}</p>
               </a>
            </div>
            <!-- User Menu -->
            <div id="user-frame" class="logged">
               <a class="frame-link" (click)="goToConsumption($event)" href="#">My consumption</a>
               <a class="frame-link" href="https://iam.ivv.desp.space/realms/desp/account/" target="_blank">Account Settings</a>
               <a class="frame-link" (click)="logout($event)" href="#">Logout</a>
            </div>
         </div>
         <!-- Mobile menu icon -->
         <div id="menu-icon-container">
            <i data-feather="menu" id="menu-icon"></i>
         </div>
      </div>
   </div>
</div>
<!-- Mobile Menu Container -->
<div id="dropdown-menu-container">
   <div class="dropdown-link">
      <a class="header-link"  routerLinkActive="active-link"
         [routerLinkActiveOptions]="{ exact: true }" routerLink="/list">Quantum Emulators</a>
   </div>
   <div class="dropdown-link">
      <a class="header-link" routerLinkActive="active-link"
         [routerLinkActiveOptions]="{ exact: true }"  routerLink="/consumption">My Consumption</a>
   </div>
   <div class="dropdown-link">
      <a class="header-link" routerLinkActive="active-link"
         [routerLinkActiveOptions]="{ exact: true }" routerLink="/">About </a>
   </div>
</div>